{
  "blocks": [
    {
      "id": "test-lh",
      "kind": "test",
      "tags": ["testing", "her", "pre-cycle", "during-cycle"],
      "title": "LH",
      "subtitle": "LH for ovulation and cycle timing",
      "icon": "🩸",
      "body": {
        "testName": "Luteinizing Hormone (LH)",
        "category": "blood-marker",
        "whatItMeasures": "LH helps coordinate ovulation; a mid-cycle rise can signal an LH surge.",
        "howItWorks": "A blood draw at any lab or clinic. Timing depends on the question: day 2-4 for baseline context, or around the middle of the cycle when checking for an ovulation surge. Fasting is usually not required unless it is bundled with other tests.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Blood"
          },
          {
            "kind": "time",
            "value": "5 min draw"
          },
          {
            "kind": "pain",
            "value": "Needle pinch"
          },
          {
            "kind": "prep",
            "value": "Timing depends on the question"
          },
          {
            "kind": "results",
            "value": "1-2 business days"
          }
        ],
        "turnaroundTime": "1-2 business days",
        "cycleDay": "Day 2-4 for baseline context; mid-cycle when checking for a surge",
        "markerTiming": [
          {
            "marker": "LH",
            "timing": "Day 2-4 for baseline; mid-cycle for a surge",
            "reason": "The same hormone answers different questions depending on when it is measured, so cycle timing belongs with the result."
          }
        ],
        "atHome": false,
        "clinicRequired": false,
        "dataPoints": ["dp-lh-level"],
        "section": "cycle-monitoring"
      },
      "sources": [
        {
          "title": "Testing and interpreting measures of ovarian reserve: a committee opinion",
          "authors": "Practice Committee of the American Society for Reproductive Medicine",
          "journal": "Fertility and Sterility",
          "year": 2020,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/testing-and-interpreting-measures-of-ovarian-reserve-a-committee-opinion-2020/",
          "evidenceLevel": "guideline"
        }
      ],
      "readTimeMinutes": 3
    }
  ],
  "relationships": [],
  "localeVariants": []
}
